import Axios from "./axiosInstance";
import { ASSIGN_LEADS } from "./uriConstant";

// axios.defaults.proxy.host = "https://dev-bsale.betagro.com"

export const assignLeads = (data) => {
    return Axios.post(`${ASSIGN_LEADS}`, data);
};
